/**
 * Format a price as Norwegian krone with dot-separated thousands.
 * Returns "Kontakt forhandler" for null prices.
 */
export const formatPrice = (price: number | null): string => {
  if (price === null) return 'Kontakt forhandler'
  return new Intl.NumberFormat('nb-NO', {
    maximumFractionDigits: 0,
    useGrouping: true,
  })
    .format(price)
    .replace(/\s/g, '.')
}
